import { useSelector } from 'react-redux';
import {
  getCommonPages,
  getModuleNames,
  getProjectHomeSections,
} from './helper';
import { useLocation } from 'react-router-dom';
import useProjectId from '@hooks/useProjectId';
import useSWRImmutable from 'swr/immutable';
import { getComplexityBoardData, getProjectStatus } from '@service/apis';
import { projectRole } from '@model';
import { useEffect } from 'react';
import { noneProjectSpecificUrl } from '@model/pagePath';

// const noneProjectSpecificUrl = [
//   '/settings', // system setting
//   '/projects/list',
//   '/projects/create',
//   '/privacy',
//   '/issue-list',
//   '/guide',
//   '/guide-shared',
// ];

const generateSWRKey = (key, projectId, shouldRequest) =>
  !projectId || !shouldRequest ? false : [projectId, key]; // projectId as first argument in fetcher

function useReportIssuePageList(requestEnabled) {
  const userInfo = useSelector(({ login }) => login.userInfo);
  const projectPermission = useSelector(
    (state) => state.common.projectCompanyInfo?.currentUserPermission,
  );
  const { customizedModules, originAccessibleModules, permissionLoading } =
    useSelector((state) => state.projects);
  const isPwcReadOnly = projectPermission === projectRole['View-Only'];
  const isInternal = userInfo.isInternal;
  const projectId = useProjectId();
  const location = useLocation();
  const outSideProject = noneProjectSpecificUrl.some((i) =>
    location.pathname.includes(i),
  );
  const shouldRequest = requestEnabled && !outSideProject;
  const projectHomeStatus = useSWRImmutable(
    generateSWRKey('projectHomeStatus', projectId, shouldRequest),
    getProjectStatus.bind(this, projectId),
  );
  const questionnaireStatus = useSWRImmutable(
    generateSWRKey('questionnaireStatus', projectId, shouldRequest),
    getComplexityBoardData.bind(this, projectId),
  );

  useEffect(() => {
    if (shouldRequest) {
      projectHomeStatus.mutate();
      questionnaireStatus.mutate();
    }
  }, [shouldRequest]);

  const isLoading =
    projectHomeStatus.isLoading ||
    questionnaireStatus.isLoading ||
    permissionLoading;

  const commonPages = getCommonPages(userInfo);

  const connectedPages =
    outSideProject && !isLoading
      ? commonPages
      : [
          ...commonPages,
          ...(isInternal && !isPwcReadOnly ? ['Project Setting'] : []),
          ...getProjectHomeSections(
            projectHomeStatus.data,
            originAccessibleModules,
          ),
          ...getModuleNames(
            customizedModules,
            originAccessibleModules,
            questionnaireStatus.data,
          ),
          // ...getQuestionnairePages(
          //   questionnaireStatus.data,
          //   customizedModules,
          //   originAccessibleModules,
          // ),
          // ...getAnalysisAndInsightPages(
          //   customizedModules,
          //   originAccessibleModules,
          // ),
          // ...getCustomizedModulesPages(
          //   customizedModules,
          //   originAccessibleModules,
          // ),
        ];
  return {
    isLoading,
    connectedPages,
  };
}

export default useReportIssuePageList;
